import { Container } from 'reactstrap'
import HistoryList from '../../../Material/HistoryList'

const HistoryTab = ({ memberId }) => (
    <Container fluid className="p-4" style={{ backgroundColor: '#fff', borderRadius: '5px' }}>
        <HistoryList objectIds={[memberId]} subject="this member" emptyText="No history found" />
    </Container>
)

export default HistoryTab
